import { DistributorPromiseThunkAction } from '../../types';
import { WithCurrencyCode } from '../../types/selectors/selectorPropTypes';
import { toUtc } from '../../utils/dates';
import { getLanguageCode } from '../app/selectors';
import { getEnterpriseTimezone } from '../entities/enterprises/selectors';
import { getEnterpriseServiceId } from '../entities/services/selectors';
import { getEndDate, getSelectedHotelId, getStartDate } from '../resourceOrder/selectors';
import { fetchPromotedServicesFailed, fetchPromotedServicesStarted, fetchPromotedServicesSucceeded } from './reducers';

export const fetchPromotedServices =
    ({ currencyCode }: WithCurrencyCode): DistributorPromiseThunkAction =>
    async (dispatch, getState, { apiService, loggerService }) => {
        const state = getState();
        const enterpriseId = getSelectedHotelId(state);
        const enterpriseTimezone = getEnterpriseTimezone(state, { enterpriseId });
        const startDate = getStartDate(state);
        const endDate = getEndDate(state);
        const serviceId = getEnterpriseServiceId(state, { enterpriseId });

        if (startDate == null || endDate == null || serviceId == null || enterpriseTimezone == null) {
            loggerService.log(
                'fetch-promoted-services-cancelled',
                'Fetching promoted services cancelled due to missing values',
                { startDate, endDate, serviceId, enterpriseTimezone }
            );
            return;
        }

        const startUtc = toUtc(startDate, enterpriseTimezone);
        const endUtc = toUtc(endDate, enterpriseTimezone);
        const languageCode = getLanguageCode(state);

        try {
            dispatch(fetchPromotedServicesStarted());
            const response = await apiService.getPromotedServices({
                endUtc,
                startUtc,
                currencyCode,
                languageCode,
                serviceId,
            });
            dispatch(fetchPromotedServicesSucceeded(response));
        } catch (error) {
            dispatch(fetchPromotedServicesFailed());
            throw error;
        }
    };
